export const bodyScrollLock = (isOpen: boolean) => {
  if (!document) return;

  if (isOpen) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
};
